import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { RegistrationMessageComponent } from 'app/modules/auth/sign-up/form-steps/registration-message/registration-message.component';
import { LinkCompanyService } from '../link-company.service';

@Component({
  selector: 'app-link-company-confirmation',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    TranslocoModule,
    RouterModule,
    RegistrationMessageComponent
  ],
  templateUrl: './link-company-confirmation.component.html',
  styleUrls: ['./link-company-confirmation.component.scss'],
})
export class LinkCompanyConfirmationComponent implements OnInit {
  private readonly _authService = inject(AuthService);
  private readonly _linkCompanyService = inject(LinkCompanyService);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  loading = true;
  error = false;
  expired = false;
  isAccepted = false;

  ngOnInit(): void {
    const result = this._route.snapshot.queryParamMap.get('result');
    const confirmation = result === 'true';
    const invitationHash = this._route.snapshot.queryParamMap.get('invitation_hash');
    const autologinHash = this._route.snapshot.queryParamMap.get('hash');

    if (!invitationHash || !autologinHash || result === null) {
      this.expired = true;
      this.loading = false;
      return;
    }

    this.isAccepted = confirmation;

    this._authService.signInFromToken(autologinHash).subscribe({
      next: () => {
        this._linkCompanyService.confirmRequest(invitationHash, confirmation).subscribe({
          next: () => {
            this.loading = false;
          },
          error: (err) => {
            if (err?.errorCode === 'REQUESTED_COMPANY_JOIN_REQUEST_ENTITY_NOT_FOUND') {
              this.expired = true;
              this.loading = false;
            } else {
              this.error = true;
              this.loading = false;
            }
          }
        });
      },
      error: () => {
        this.expired = true;
        this.loading = false;
      }
    });
  }

  close(): void {
    this._router.navigate(['/devices'])
  }

  onSubmit(): void {
    this._router.navigate(['/devices']);
  }
}
